import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PreloaderComponent from '#component/preloader';
import Map from './mapbox';

export const MapWithPreloader = props => {
  const { loading, locations, ...restProps } = props;
  const meta = useSelector(s => s.meta);
  const account = useSelector(s => s.account);
  const dispatch = useDispatch();

  if (loading) {
    return <PreloaderComponent style={{ transform: 'initial' }} />;
  }

  return <Map
    locations={locations}
    meta={meta}
    {...restProps}
    dispatch={dispatch}
    account={account}
  />;
};
